// src/components/AboutSection.jsx
import React from 'react';
import './AboutSection.css';

const AboutSection = () => {
  return (
    <div id="about" className="about-section">
      <div className="content">
        <h2>About Royal Suites Service Apartments</h2>
        <p>
          At Royal Suites Service Apartments, we are committed to providing a luxurious and comfortable stay for our guests.
          Located in the heart of Gachibowli, our properties are designed to meet the needs of both business and leisure travelers.
        </p>
        <p>
          With modern amenities, spacious accommodations, and a dedicated team, we ensure a memorable experience for every guest.
          Whether you're here for a short visit or an extended stay, Royal Suites Service Apartments offers the perfect blend of comfort and convenience.
        </p>
      </div>
    </div>
  );
};

export default AboutSection;
